let basePath, originPath, dictPath, webSockUrl, webSockAgreeOn
if (process.env.NODE_ENV === 'production' && process.env.RUN_ENV === 'production') {
  //正式
  basePath = '//yzims.oss-cn-shenzhen.aliyuncs.com/'
  originPath = 'https://static.yzou.cn/'
  dictPath = '//static.yzou.cn/cache/'
  webSockUrl = '//monitor-exam.yzou.cn'
  webSockAgreeOn = 'wss'
} else if (process.env.NODE_ENV === 'production' && process.env.RUN_ENV === 'devtest') {
  //预发布
  basePath = 'http://img2.yzwill.cn/'
  originPath='http://img2.yzwill.cn/';
  dictPath = "//img2.yzwill.cn/cache/pre/";
  webSockUrl = '//xk-exam.yzou.cn'
  webSockAgreeOn = 'wss'
} else if (process.env.NODE_ENV === 'development') {
  // 本地
  basePath = 'http://img2.yzwill.cn/'
  originPath = 'http://img2.yzwill.cn/'
  dictPath = "//img2.yzwill.cn/cache/pre/";
  webSockUrl = '//xk-exam.yzou.cn' // 192
  webSockAgreeOn = 'ws'
}
module.exports = {
  imgBaseURL: originPath,
  // 上传图片的
  imgBasePath: originPath,
  webSockUrl: webSockUrl,
  dict: `${dictPath}dict.js?${Date.now()}`,
  webSockAgreeOn: webSockAgreeOn
}



// WEBPACK FOOTER //
// ./src/config/index.js